var calculatePriceTaxFeeAdjusters = function calculatePriceTaxFeeAdjusters(purchaseService, which) {
  var _calculatePriceTaxFeeAdjusters = function _calculatePriceTaxFeeAdjusters() {
    purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return !['ebt', 'taxfreesale'].includes(a.name);
    }).sort(function (a, b) {
      return Math.sign(a.priority - b.priority);
    }).forEach(function (a) {
      if (which !== 'justcash') {
        a.calculate(purchaseService.purchases);
      }
      if (which !== 'justcc' && a.name !== 'feebuster' && purchaseService.feeBusterConfig.enabled) {
        a.calculate(purchaseService.getCashPricePurchases());
      }
    });
    purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return !['ebt', 'taxfreesale'].includes(a.name);
    }).sort(function (a, b) {
      return Math.sign(a.priority - b.priority);
    }).forEach(function (a) {
      if (!a.calculateInt) {
        console.error(a.name + " has no calculateInt function!\n  On the simplest level this can be done by haveing your PTF class\n  extend ptfService.priceTaxFeeAdjusterBase");
        return;
      }
      if (which !== 'justcash') {
        a.calculateInt(purchaseService.purchases);
      }
      if (which !== 'justcc' && a.name !== 'feebuster' && purchaseService.feeBusterConfig.enabled) {
        a.calculateInt(purchaseService.getCashPricePurchases());
      }
    });

    // some PTFs must be calculated after all other values have been rounded
    purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return ['ebt', 'taxfreesale'].includes(a.name);
    }).sort(function (a, b) {
      return a.priority - b.priority;
    }).forEach(function (a) {
      if (which !== 'justcash') {
        a.calculate(purchaseService.purchases);
        a.calculateInt(purchaseService.purchases);
      }
      if (which !== 'justcc' && a.name !== 'feebuster' && purchaseService.feeBusterConfig.enabled) {
        a.calculate(purchaseService.getCashPricePurchases());
        a.calculateInt(purchaseService.getCashPricePurchases());
      }
    });
  };
  _calculatePriceTaxFeeAdjusters();
  return purchaseService;
};
module.exports = calculatePriceTaxFeeAdjusters;